import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import DesktopRouter from './DesktopRouter'
import MobileRouter from './MobileRouter'
import useIsMobile from '../hooks/useIsMobile'

const RootRouter = () => {
  const { pathname } = useLocation()

  const isMobile = useIsMobile()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return isMobile ? <MobileRouter /> : <DesktopRouter />
}

export default RootRouter
